import axios from "../../axiosClient";

export const getEnergyConsumptionDataByBlockCode = async (
  blockCode: any,
  charttype: any,
  location: any,
  locationtype: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getEnergyConsumptionDataByBlockCodeLevelAndLocation`,
    {
      params: {
        blockCode: blockCode,
        charttype: charttype,
        location,
        locationtype,
      },
      signal,
    }
  );

  return res?.data;
};
